import { addStyles } from "@/utils";
import React, { useEffect, useMemo, useState } from "react";
import { FC } from "react";

export const RouterGuard: FC = ({ children }) => {
  const path = window.location.pathname;

  const [unRendCss] = useState(["/u", "/launchpad"]);

  const isRender = useMemo(() => !unRendCss.includes(path), [path, unRendCss]);
  // 样式隔离 Guard 与 应用面板、个人中心都隔离开

  const config = window.__config__;

  const styles: string | any = config?.css;
  let styleElt: HTMLStyleElement | undefined, styleSheet: any;

  if (isRender && styles) {
    const res = addStyles(styles);
    styleElt = res.styleElt;
    styleSheet = res.styleSheet;
  }
  useEffect(() => {
    return () => {
      if (isRender && styles) {
        styleElt && styleElt.remove();
        if ((document as any).createStyleSheet) document.removeChild(styleSheet);
      }
    };
  }, [isRender, path, styleElt, styleSheet, styles]);

  return <>{children}</>;
};
